import 'dayjs/locale/pt-br';
import dayjs, { Dayjs } from 'dayjs';
import { styled } from '@mui/system';
import { useState, useEffect } from 'react';

import { Typography } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

dayjs.locale('pt-br');

type ParamsDate = {
    arrayListDates: Array<{
        date: string
    }>;
    handleDateSelected: (date: string) => void;
}

const Container = styled('div')(
    ({ theme }) => `
        padding: .1rem;
        border-radius: 8px;
        border: 2.8px solid ${theme.palette.primary.main};

        @media(min-width: ${theme.breakpoints.values.md}px) {
            padding: .3rem;
        }
`);

const ContainerDatePicker = styled('div')(
    ({ theme }) => `
        .MuiCalendarPicker-root {
            background-color: #ffffff;

            span {
                font-weight: 500;
                color: ${theme.palette.primary.main};
            }

            .MuiButtonBase-root {
                font-weight: 600;
                font-size: .875rem;
                background-color: #D9D9D9;
                color: ${theme.palette.primary.main};;

                &:disabled {
                    background-color: transparent;
                    color: ${theme.palette.grey[200]};
                }

                &.Mui-selected {
                    color: ${theme.palette.primary.main};
                    background-color: ${theme.palette.secondary.main};
                }

                svg {
                    path {
                        fill: ${theme.palette.primary.main};
                        stroke: ${theme.palette.primary.main};
                    }
                }
            }
        }
`);

const DatePicker = ({ arrayListDates, handleDateSelected }: ParamsDate) => {
    // const { handleSelectedDate } = useContext(DataContext);
    const [valueDate, setValueDate] = useState<Dayjs | null>(dayjs(new Date()));

    const handleNewDate = (newValue: Dayjs | null) => {
        setValueDate(newValue);

        // handleSelectedDate(newValue);
        handleDateSelected(newValue!.format('DD/MM/YYYY'));
    }

    const handleIsAvailable = (dateDP: Dayjs) => {
        const isAvailable = arrayListDates?.some(({ date }) => date === dateDP.format('DD/MM/YYYY'));

        return !isAvailable;
    }

    const handleChangedName = (e: string) => {
        switch (e) {
            case '2ª':
                return 'Seg';
            case '3ª':
                return 'Ter';
            case '4ª':
                return 'Qua';
            case '5ª':
                return 'Qui';
            case '6ª':
                return 'Sex';
            default:
                return e;
        }
    }

    useEffect(() => {
        if (arrayListDates.length > 0) {
            const [day, month, year] = arrayListDates[0]?.date.split('/');

            handleNewDate(dayjs(`${year}-${month}-${day}`));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayListDates]);

    return (
        <div>
            <Typography fontSize='1.25rem' fontWeight={700} paddingBottom='.5rem'>
                DATA
            </Typography>
            <Container>
                <LocalizationProvider dateAdapter={AdapterDayjs} localeText={{ previousMonth: 'Mês anterior', nextMonth: 'Próximo mês' }}>
                    <ContainerDatePicker>
                        <StaticDatePicker
                            displayStaticWrapperAs="desktop"
                            dayOfWeekFormatter={(day: string) => handleChangedName(day)}
                            openTo="day"
                            value={valueDate}
                            shouldDisableDate={handleIsAvailable}
                            onChange={(newValue) => {
                                handleNewDate(newValue);
                            }}
                        />
                    </ContainerDatePicker>
                </LocalizationProvider>
            </Container>
        </div>
    );
}

export default DatePicker;